export default __webpack_public_path__ + "static/media/hero.4671b77a.jpg";